import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import AllInboxSharpIcon from '@mui/icons-material/AllInboxSharp';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';
import { Button, Switch, Tooltip, debounce } from '@mui/material';
import electro from 'assets/electronics-top-icon.png';
import arm from 'assets/robotArm.png';
import { ROUTES } from 'base/routes/routes';
import LoadingBCScreen from 'base/ui/components/LoadingScreen/loadingBCScreen';
import { observer } from 'mobx-react';
import moment from 'moment';
import { StatusColor } from 'pages/report/BC01machineStatus/machineStatus';
import { useCallback, useEffect, useRef, useState } from 'react';
import { IoArrowBackCircle, IoChevronBackCircleSharp, IoChevronForwardCircleSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import ShowMoreText from 'react-show-more-text';
import { BC02, BC02PopupModel, PopUpDataDetail, dataWSE } from 'services/report_services';
import * as rootStore from 'stores/root_store';
import { formatNumber } from 'utils/formatHelper';
import './viewSlideDetails.css';

// ==================================================
import type { ProColumns } from '@ant-design/pro-components';
import { ProTable } from '@ant-design/pro-components';
import { Tooltip as AntdTooltip, Form, InputNumber, Modal, Select, Button as CustomButton } from 'antd';
import CustomProTable from 'base/ui/components/CustomTable';
import { toast } from 'react-toastify';
import { workOrderPendingModel } from 'services/report_services';
import { columnsTable1 } from '../columnsTable';
import { AiOutlineDownload } from 'react-icons/ai';

export function createProductionPlanViewSlideDetails() {
  return observer(() => {
    const [form] = Form.useForm();
    // navigate
    const navigate = useNavigate();
    const runRef = useRef<HTMLButtonElement>(null);
    //loading page when reload
    const [isLoading, setIsLoading] = useState(false);
    // gán lại mảng id ban đầu chưa qua thay đổi
    const [listIdSelected, setListIdSelected] = useState([...rootStore.reportStore.stateItemId]);
    //  id máy đang show
    const [idSelected, setIdSelected] = useState<string>();
    // Kiểm tra xem danh sách máy có trống hết hay không
    const [checkEmpty, setCheckEmpty] = useState(false);
    // Lưu lại id của setInterval
    // const [intervalID, setIntervalID] = useState<number | undefined>(undefined);
    const intervalRef = useRef<any | null>(null);
    // kiểm tra auto run
    const [autoRun, setAutoRun] = useState(false);
    // chuyển trạng thái show card hoặc show detail
    const [showCard, setShowCard] = useState(false);

    // sự kiện nút sắp xếp bảng 2
    const [showSave, setShowSave] = useState(false);

    const [dataProduct, setDataProduct] = useState<BC02>();
    const [workOrderPendings, setWorkOrderPendings] = useState<workOrderPendingModel[]>([]);
    const [workOrderSelected, setWorkOrderSelected] = useState<workOrderPendingModel[]>([]);
    // Sử dụng State để lưu các trạng thái được lọc để tiến hành render
    const [dataESR, setDataESR] = useState<dataWSE[] | undefined>(undefined);
    // data show in popup
    const [dataPopup, setDataPopup] = useState<BC02PopupModel | undefined>(undefined);

    const date = new Date().toLocaleDateString('en-GB');

    //handle cập nhật thay đổi thông tin
    const handleChangeEquipCard = async (
      value: {
        value: string;
        label: string;
      }[],
      option:
        | {
          value: string;
          label: string;
        }
        | {
          value: string;
          label: string;
        }[],
      index: number,
    ) => {
      if (option && Array.isArray(option)) {
        const dataTemp = { ...dataPopup };
        dataTemp?.chiTiets?.splice(index, 1, {
          ...dataTemp.chiTiets[index],
          barcode: option.map((b) => ({
            barcodeName: b.label,
            equipmentCardId: b.value,
          })),
        });
        setDataPopup(dataTemp);
      } else {
      }
    };

    // HANDLE OPEN POP UP
    const handleOnClickOpen = async (item: workOrderPendingModel) => {
      await rootStore.reportPresenter.getDataPopupBC02(rootStore.reportStore, item.lsxId);
      if (rootStore.reportStore.BC02PopupResponse.isSuccess) {
        const temp = { ...rootStore.reportStore.BC02PopupResponse.data };
        temp.chiTiets?.map(
          (c) => (c.listBarcode = c.barcode?.map((b) => ({ label: b.barcodeName, value: b.equipmentCardId }))),
        );
        setDataPopup(rootStore.reportStore.BC02PopupResponse.data);
      }
      setOpen(true);
    };

    const getDataBC02 = async (id: string) => {
      setIsLoading(true);
      await rootStore.reportPresenter.getBC02(rootStore.reportStore, {
        equipmentCardId: id,
      });
      if (rootStore.reportStore.BC02Response.isSuccess) {
        setDataProduct(rootStore.reportStore.BC02Response.data);
        setWorkOrderPendings(rootStore.reportStore.BC02Response.data?.lsxDangCho || []);
        setWorkOrderSelected(rootStore.reportStore.BC02Response.data?.lsxDaChon || []);
      }
      setIsLoading(false);
    };

    // get data dropdown danh sách máy/truyền công đoạn
    const getListEquipCard = async (stepCode: string, value = '', index: number) => {
      await rootStore.reportPresenter.getDropdownBC02(rootStore.reportStore, stepCode, value);
      if (rootStore.reportStore.BC02DropdownResponse.isSuccess) {
        const temp = { ...dataPopup };
        temp.chiTiets!.at(index)!.listBarcode = rootStore.reportStore.BC02DropdownResponse.data!.map((i) => {
          return {
            label: i.equipmentName,
            value: i.equipmentCardId,
          };
        });
        setDataPopup(temp);
      }
    };
    // debounce dropdown
    const debounceHandler = useCallback(debounce(getListEquipCard, 300), []);

    const getDataSelected = async (type?: 'prev') => {
      // duyệt qua mảng id để lấy data
      // nếu bấm nút prev thì đảo ngược mảng lại để lấy id trước đó
      const data =
        type === 'prev' ? [...rootStore.reportStore.stateItemId.reverse()] : [...rootStore.reportStore.stateItemId];
      await rootStore.reportPresenter.WorkShopEquipments(rootStore.reportStore, null, [], null, [], undefined, rootStore.reportStore.stateItemId);
      if (rootStore.reportStore.WorkShopEquipmentsStatus.isSuccess) {
        // biến danh sách máy thành 1 mảng duy nhất
        const map = rootStore.reportStore.WorkShopEquipmentsStatus.data.flatMap((i) => i.workShopEquipments);
        // tìm những máy trong danh sách id
        // const dataESRTemp = map.filter((item) => rootStore.reportStore.stateItemId.includes(item.id));
        const dataESRTemp = listIdSelected.map((id) => {
          return map.find((item) => item.id === id);
        }) as dataWSE[];
        // lọc ra những máy trống
        setDataESR(dataESRTemp);

        let empty = false;
        for (let i = 0; i < rootStore.reportStore.stateItemId.length; i++) {
          // const status = await rootStore.commonDatePresenter.getStatusEquipByID(data.at(i) as string);
          const status = dataESRTemp.find((it) => it.id === (data.at(i) as string))?.status;
          // duyệt mảng để check máy có hoạt dộng hay không
          if (status !== 'Trống') {
            // setCheckEmpty(false);
            empty = false;
            setIdSelected(data.at(i) as string);

            const temp = [...rootStore.reportStore.stateItemId];
            // dời các phàn từ đầu ra phía sau
            // để các máy chạy theo 1 vòng và có tuần tự thì phải dời các máy ngưng hoạt động và máy đang chọn ra cuối

            // lấy từ đầu tới máy đang hoạt động
            const firstFourElements = temp.slice(0, i + 1);
            // lâý từ máy đang hoạt động đến cuối
            const remainingElements = temp.slice(i + 1);
            // đảo trước ra sau
            const newData = remainingElements.concat(firstFourElements);
            // set lại mảng
            await getDataBC02(data.at(i) as string);
            // await getDataListCard();
            rootStore.reportPresenter.setItemId(rootStore.reportStore, type === 'prev' ? newData.reverse() : newData);

            break;
          } else {
            setIdSelected(undefined);
            // setDataESR(undefined);
            setDataProduct(undefined);
            empty = true;
          }
        }

        if (!empty) {
          setShowCard(false);
        }
        setCheckEmpty(empty);
      }
    };

    // Hàm khởi chạy đầu tiên để lấy data của máy hoạt động
    useEffect(() => {
      if (rootStore.reportStore.stateItemId.length) {
        if (checkEmpty) {
          setShowCard(true);
          intervalRef.current = setInterval(async () => {
            await getDataSelected();
          }, 15 * 1000);
          // setShowCard(true);
        } else {
          (async () => {
            await getDataSelected();
            setAutoRun(true);
            // setShowCard(true);
          })();
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
          }
        }
      } else {
        navigate(ROUTES.REPORTS.REPORT_KHSX.LINK);
      }
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }, [checkEmpty]);

    // lấy danh sách máy (hiển thị máy đang hoạt động)
    // const getDataListCard = async () => {
    //   await rootStore.reportPresenter.WorkShopEquipments(rootStore.reportStore, null, [], null, []);
    //   if (rootStore.reportStore.WorkShopEquipmentsStatus.isSuccess) {
    //     // biến danh sách máy thành 1 mảng duy nhất
    //     const map = rootStore.reportStore.WorkShopEquipmentsStatus.data.flatMap((i) => i.workShopEquipments);
    //     // tìm những máy trong danh sách id
    //     // const dataESRTemp = map.filter((item) => rootStore.reportStore.stateItemId.includes(item.id));
    //     const dataESRTemp = listIdSelected.map((id) => {
    //       return map.find((item) => item.id === id);
    //     }) as dataWSE[];
    //     // lọc ra những máy trống
    //     setDataESR(dataESRTemp);
    //   }
    // };

    // ============================== HANDLE POPUP ==================================
    // OPEN POP UP DIALOG
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    // Hàm sử lí nút lưu
    const handleOk = async () => {
      setConfirmLoading(true);
      setTimeout(() => {
        setOpen(false);
        setConfirmLoading(false);
      }, 2000);
      await rootStore.reportPresenter.saveChooseEquipment(rootStore.reportStore, {
        mmths: dataPopup?.chiTiets!.map((item) => ({
          idRouting: item.id,
          equipmentCardId: item.barcode?.map((i) => i.equipmentCardId),
        })),
      });
      getDataBC02(idSelected as string);
      if (rootStore.reportStore.SaveResponse.isSuccess) {
        toast.success(rootStore.reportStore.SaveResponse.message);
      } else {
        toast.error(rootStore.reportStore.SaveResponse.message);
      }
    };
    const handleCancel = () => {
      setOpen(false);
    };

    //=============================== Kéo dòng trong table =================================

    const columnsPopup: ProColumns[] = [
      // STT Công đoạn
      {
        title: 'STT Công đoạn',
        dataIndex: 'sttCongDoan',
        key: 'sttCongDoan',
        width: 150,
        align: 'center',
      },
      // STT Công đoạn
      {
        title: 'Công đoạn',
        dataIndex: 'tenCongDoan',
        key: 'tenCongDoan',
        width: 200,
      },
      // STT Công đoạn
      {
        title: 'Máy/Chuyền',
        dataIndex: 'mayChuyen',
        key: 'mayChuyen',
        render: (_, record: PopUpDataDetail, index) => {
          return {
            props: {},
            children: (
              <Select
                className="!w-full"
                size="small"
                mode="multiple"
                showSearch
                value={
                  dataPopup?.chiTiets?.at(index)?.barcode?.length
                    ? dataPopup?.chiTiets
                      ?.at(index)
                      ?.barcode?.map((t) => ({ label: t.barcodeName, value: t.equipmentCardId }))
                    : []
                }
                options={dataPopup?.chiTiets?.at(index)?.listBarcode || []}
                onFocus={async () => {
                  await getListEquipCard(record.congDoan, '', index);
                }}
                allowClear
                onSearch={async (value) => {
                  // setDataDropDown([]);
                  await debounceHandler(record.congDoan, value, index);
                }}
                filterOption={false}
                onClear={() => {
                  const tempt = { ...dataPopup };

                  tempt.chiTiets!.at(index)!.barcode = undefined;
                  setDataPopup(tempt);
                }}
                onChange={(value, option) => handleChangeEquipCard(value, option, index)}
              />
            ),
          };
        },
      },
    ];

    // table head of drag table
    const columns: ProColumns[] = [
      {
        title: 'STT',
        width: 25,
        dataIndex: 'stt',
        key: 'stt',
        fixed: 'left',
        className: 'text-center ',
        align: 'center',
      },
      // khách hàng
      {
        title: 'Khách hàng',
        width: 50,
        dataIndex: 'khachHang',
        key: 'khachHang',
      },
      // Loại LSX
      {
        title: 'Loại LSX',
        dataIndex: 'loaiLSX',
        key: 'loaiLSX',
        width: 35,
      },
      // lệnh sản xuất
      {
        title: 'LSX',
        width: 40,
        dataIndex: 'lsx',
        key: 'lsx',
        className: '',
        render: (text) => {
          return {
            props: {
              style: {
                fontWeight: 'bold',
              },
            },
            children: text,
          };
        },
      },
      // thành phẩm/bán thành phẩm
      {
        title: 'TP/BTP',
        dataIndex: 'tpbtp',
        key: 'tpbtp',
        width: 50,
        render: (text, record) => {
          return <AntdTooltip title={text}>{text}</AntdTooltip>;
        },
      },
      // Ngày yêu cầu có hàng in
      {
        title: 'Ngày YC có hàng in',
        width: 60,
        dataIndex: 'ngayYeuCauCoHangIn',
        key: 'ngayYeuCauCoHangIn',
        render(text, record) {
          return record.ngayYeuCauCoHangIn ? moment(record.ngayYeuCauCoHangIn).format('DD/MM/YYYY HH:mm') : '-';
        },
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Ngày hàng in về
      {
        title: 'Ngày hàng in về',
        width: 60,
        dataIndex: 'ngayHangInVe',
        key: 'ngayHangInVe',
        render(text, record) {
          return record.ngayHangInVe ? moment(record.ngayHangInVe).format('DD/MM/YYYY HH:mm') : '-';
        },
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // Số SP/Tờ/Công đoạn
      {
        title: 'Số SP/Tờ/CĐ',
        width: 30,
        dataIndex: 'soSPToCongDoan',
        key: 'soSPToCongDoan',
        className: 'text-right',
        // render: (text, record) => {
        //   return formatNumber(record.soSPToCongDoan, 0);
        // },
      },
      // số lượng phát lệnh
      {
        title: 'SL phát lệnh',
        width: 30,
        dataIndex: 'slPhatLenh',
        key: 'slPhatLenh',
        className: 'text-right',
        render: (text) => {
          return formatNumber(Number(text), 0);
        },
      },
      // số lượng tờ(SP) qui đổi
      {
        title: 'SL tờ (SP) qui đổi',
        width: 40,
        dataIndex: 'soLuongToQuyDoi',
        key: 'soLuongToQuyDoi',
        className: 'text-right',
        render: (text, record) => {
          return formatNumber(record.soLuongToQuyDoi, 0);
        },
      },
      // đơn vị tính
      {
        title: 'ĐVT',
        width: 20,
        dataIndex: 'dvt',
        key: 'dvt',
        className: '',
      },
      // Thời gian giao hàng
      {
        title: 'TG giao hàng',
        width: 50,
        dataIndex: 'tgGiaoHang',
        key: 'tgGiaoHang',
        render(text, record) {
          return <>{record.tgGiaoHang ? moment(record.tgGiaoHang).format('DD/MM/YYYY HH:mm') : '-'}</>;
        },
        onCell: (_, index) => ({
          className: 'text-center',
        }),
      },
      // công đoạn
      {
        title: 'Công đoạn',
        dataIndex: 'congDoan',
        key: 'congDoan',
        width: 105,
      },
      // thứ tự công đoạn
      {
        title: 'Thứ tự CĐ',
        width: 30,
        dataIndex: 'thuTuCongDoan',
        key: 'thuTuCongDoan',
        className: 'text-right',
      },

      // hướng dẫn sản suất
      {
        title: 'Hướng dẫn SX',
        width: 70,
        dataIndex: 'hdsx',
        key: 'hdsx',
      },
      // NVL sử dụng
      {
        title: 'NVL sử dụng',
        width: 80,
        dataIndex: 'nvlSuDung',
        key: 'nvlSuDung',
      },
      // máy/truyền thực hiện
      {
        title: '',
        dataIndex: 'chucNang',
        key: 'chucNang',
        width: 15,
        render: (text, record) => {
          return (
            <>
              <EditIcon onClick={() => handleOnClickOpen(record)} className="!text-[15px] float-right" />
            </>
          );
        },
      },
      {
        title: 'Máy/Chuyền thực hiện',
        dataIndex: 'mayChuyenThucHien',
        key: 'mayChuyenThucHien',
        width: 70,
        fixed: 'right',
        className: 'whitespace-nowrap text-ellipsis overflow-hidden !py-1',
        render: (text, record) => {
          return (
            <>
              <AntdTooltip title={text}>{text}</AntdTooltip>
              <EditIcon onClick={() => handleOnClickOpen(record)} className="!text-[15px] float-right" />
            </>
          );
        },
      },
    ];

    const [columnTable1, setColumnTable1] = useState<ProColumns[]>(columnsTable1);
    const [columnsSelected, setColumnsSelected] = useState(columns);
    const [columnsPending, setColumnsPending] = useState(columns);

    const [check, setCheck] = useState(false);

    useEffect(() => {
      (async () => {
        if (check) {
          await getDataBC02(idSelected || '');
          setCheck(false);
        }
      })();
    }, [check]);

    useEffect(() => {
      let run: any;
      if (autoRun && !checkEmpty) {
        if (showCard) {
          run = setInterval(async () => {
            // if (!checkEmpty) {
            await getDataSelected();
            setShowCard(false);
            // }
          }, 15 * 1000);
        } else {
          run = setInterval(async () => {
            setShowCard(true);
          }, 30 * 1000);
        }
        setShowSave(false);
      } else {
      }
      return () => {
        clearInterval(run);
      };
    }, [autoRun, showCard]);

    // set cột cho table 2,3 vì có 1 vài cột khác nhau nên dùng chung defaultColumns
    useEffect(() => {
      (() => {
        const tempt = columnsSelected.filter((item) => item.dataIndex !== 'mayChuyenThucHien');
        tempt.shift();
        tempt.splice(0, 0, {
          title: 'Sắp xếp',
          dataIndex: 'orderIndex',
          key: 'orderIndex',
          width: 30,
          onCell: (_, index) => ({
            className: 'text-center',
          }),
          render(dom, entity, index) {
            return (
              <Form
                initialValues={{ orderIndex: dom === '-' ? undefined : dom }}
                onFinish={async (fieldsValue: any) => {
                  const orderIndex = fieldsValue['orderIndex'];
                  await rootStore.reportPresenter.sortRowBC02Selected(rootStore.reportStore, {
                    mths: [
                      {
                        id: entity.id,
                        orderIndex: orderIndex,
                      },
                    ],
                  });
                  setCheck(true);
                }}
              >
                <Form.Item name={'orderIndex'}>
                  <InputNumber disabled={!showSave} size="small" controls={false} className="!w-full" />
                </Form.Item>
              </Form>
            );
          },
        });
        // tempt.pop();
        setColumnsSelected(tempt);
        // }
      })();
    }, [showSave]);

    return (
      <div>
        {!checkEmpty && (
          <div
            className={`fixed text-black rounded-lg z-30
            top-20 right-5 align-middle
            p-1 cursor-pointer text-sm`}
          >
            <div className="text-center">
              <span>Chạy tự động</span>
              <Switch
                size="small"
                className="!text-[45px] text-center"
                ref={runRef}
                checked={autoRun}
                onChange={(e) => {
                  setAutoRun(e.target.checked);
                }}
              />
            </div>
          </div>
        )}
        <div>
          {/* nút prev */}
          <Button
            className="!text-[40px] !opacity-50 !hover:opacity-100 !flex j!ustify-end !fixed !top-[20%] z-10"
            onClick={() => {
              if (showCard) {
                (async () => {
                  setShowCard(false);
                  await getDataSelected('prev');
                })();
              } else {
                setShowCard(true);
              }
              setShowSave(false);
            }}
          >
            <IoChevronBackCircleSharp />
          </Button>
          {/* nút next */}
          <Button
            className="!text-[40px] !opacity-50 !hover:opacity-100 !flex !justify-start !fixed !top-[20%] !right-0 z-10"
            onClick={() => {
              if (showCard) {
                (async () => {
                  setShowCard(false);
                  await getDataSelected();
                })();
              } else {
                setShowCard(true);
              }
              setShowSave(false);
            }}
          >
            <IoChevronForwardCircleSharp />
          </Button>
        </div>
        {/* )} */}
        <div className="w-full  py-3 px-5 relative">
          <div className="title text-center ">
            <span
              onClick={() => navigate(ROUTES.REPORTS.REPORT_KHSX.LINK)}
              className="flex items-center text-xs text-primary cursor-pointer font-medium w-fit"
            >
              <IoArrowBackCircle className="mr-2 text-base text-gray-500" />
              Quay lại
            </span>
            <h3 className="text-md font-bold text-gray-800 mb-2 uppercase">
              KẾ HOẠCH SẢN XUẤT THEO MÁY MÓC / CHUYỀN SẢN XUẤT
            </h3>
            <span className="italic text-xs underline">Ngày : {date}</span>
            <CustomButton
              size="middle"
              loading={isLoading}
              onClick={() => {
                rootStore.reportPresenter.exportDataBC02({ equipmentCardId: idSelected });
              }}
              className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1 !absolute top-[30px] right-[160px]"
              type="primary"
            >
              <AiOutlineDownload className="block text-base" />
              <span className="block">Export Excel</span>
            </CustomButton>
          </div>

          {isLoading && <LoadingBCScreen />}

          {dataProduct ? (
            <div className={`w-full bg-white py-3 px-5 rounded ${showCard ? 'hidden' : 'block'}`}>
              <div className="w-full bg-white py-3 flex rounded mb-2 border border-neutral-300">
                <div className="w-full pt-2 lg:grid lg:grid-cols-8 flex flex-col">
                  {/* col 1 */}
                  <div className="col-span-3">
                    {/* Tên máy/ Chuyền*/}
                    <div className="w-zfull sm:flex-row  sm:items-center grid grid-cols-3 gap-x-10">
                      <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">
                        Tên máy/ Chuyền
                      </label>
                      <span className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                        {dataProduct && dataProduct?.tenMayChuyen}
                      </span>
                    </div>
                    {/* Công đoạn */}
                    <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3 gap-x-10">
                      <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">Công đoạn</label>
                      <span className="col-span-2  min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                        <ShowMoreText lines={1} more="xem tiếp..." less="...ẩn bớt" expanded={false}>
                          {dataProduct && dataProduct?.congDoan}
                        </ShowMoreText>
                      </span>
                    </div>
                    {/* Trạng thái */}
                    <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3 gap-x-10">
                      <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">Trạng thái</label>
                      <span
                        className={`
                      ${dataProduct && dataProduct?.trangThai === StatusColor.HD ? 'bg-green-500' : ''}
                  ${dataProduct && dataProduct?.trangThai === StatusColor.CM ? 'bg-[#FEF5AC]' : ''}
                  ${dataProduct && dataProduct?.trangThai === StatusColor.VS ? 'bg-[#C1EFFF]' : ''}
                  ${dataProduct && dataProduct?.trangThai === StatusColor.NM ? 'bg-[#FFB3B3]' : ''}
                  ${dataProduct && dataProduct?.trangThai === StatusColor.ET ? 'bg-white' : ''}
                      col-span-2  min-h-[30px] font-medium
                      text-gray-900 border-b border-gray-300
                      sm:ml-5 px-3 py-1.5 text-xl
                      focus-visible:outline-none focus:border-blue-500 caret-blue-600`}
                      >
                        {dataProduct && dataProduct?.trangThai}
                      </span>
                    </div>
                    {/* Lý do ngưng máy */}
                    <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3 gap-x-10">
                      <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">
                        Lý do ngưng máy
                      </label>
                      <span className="col-span-2  min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                        <ShowMoreText lines={1} more="xem tiếp..." less="...ẩn bớt" expanded={false}>
                          {dataProduct && dataProduct?.lyDoNgungMay}
                        </ShowMoreText>
                      </span>
                    </div>
                  </div>
                  {/* col 2 */}
                  <div className="col-span-3">
                    {/* Số công nhân đang đứng ca */}
                    <div className="w-full sm:flex-row sm:items-center grid grid-cols-3 gap-x-10">
                      <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">
                        SL CN đứng ca
                      </label>
                      <span className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                        {dataProduct && dataProduct?.soCNDungCa}
                      </span>
                    </div>
                    {/* Thời gian bắt đầu */}
                    <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3 gap-x-10">
                      <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">
                        Thời gian bắt đầu
                      </label>
                      <span className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                        {dataProduct?.tgBatDau ? moment(dataProduct?.tgBatDau).format('DD/MM/YYYY HH:mm') : '-'}
                      </span>
                    </div>
                    {/* TG dự kiến hoàn thành */}
                    <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3 gap-x-10">
                      <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">
                        TG dự kiến hoàn thành
                      </label>
                      <span className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                        {dataProduct?.tgDuKienHoanThanh
                          ? moment(dataProduct?.tgDuKienHoanThanh).format('DD/MM/YYYY HH:mm')
                          : '-'}
                      </span>
                    </div>
                    {/*Ghi chú */}
                    <div className="w-full sm:flex-row  sm:items-center grid grid-cols-3 gap-x-10">
                      <label className="min-w-[150px] font-medium text-xl text-gray-500 sm:text-end ">Ghi chú</label>
                      <span className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-xl focus-visible:outline-none focus:border-blue-500 caret-blue-600">
                        <ShowMoreText lines={1} more="xem tiếp..." less="...ẩn bớt" expanded={false}>
                          {dataProduct && dataProduct?.ghiChu}
                        </ShowMoreText>
                      </span>
                    </div>
                  </div>
                  {/* col 3 */}
                  <div className="col-span-2 pl-10">
                    {/* Danh sách công nhân */}
                    <div className="w-full sm:flex-row  sm:items-center grid grid-cols-1">
                      <label className="min-w-[150px] font-medium text-lg text-gray-500 border-b text-center">
                        Danh sách công nhân
                      </label>
                      <div className="max-h-96 overflow-auto">
                        {dataProduct &&
                          dataProduct?.danhSachCongNhan?.map((item, index) => {
                            return (
                              <div
                                key={index}
                                className="col-span-2 min-h-[30px] font-medium text-gray-900 border-b border-gray-300 sm:ml-5 px-3 py-1.5 text-lg focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                              >
                                {item}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                  <div className="col-span-8">
                    <CustomProTable
                      handleResize={() => { }}
                      columns={columnTable1}
                      rowKey="lsxDangThucHien"
                      bordered
                      options={false}
                      pagination={false}
                      dataSource={dataProduct?.lsxDangThucHien}
                      className="[&_.ant-table-cell]:!p-1 [&_.ant-table-thead>tr>th]:text-[15px] mt-2"
                    // scroll={{ x: 1700, y: 500 }}
                    // className="mt-4 [&_.ant-table-tbody>tr>td]:!font-sans  [&_.ant-pro-card-body]:!p-0 [&_.ant-table-thead>tr>th]:!bg-[#1677FF] [&_.ant-table-thead>tr>th]:!text-white [&_.ant-table-thead>tr>th]:text-[16px] [&_.ant-table-thead>tr>th]:!font-bold"
                    />
                  </div>
                </div>
              </div>
              {/* =========== Table PO ===============*/}
              <div>
                {/* các lệnh sản xuất đã chọn */}
                <div className="flex gap-4 mb-1 items-center text-xl">
                  <h4 className="font-bold text-base">
                    Các LSX đang chờ thực hiện của máy/chuyền: {dataProduct && dataProduct?.tenMayChuyen}
                  </h4>
                  <CustomButton
                    type="primary"
                    onClick={(e) => {
                      if (showSave) {
                        // e.stopPropagation()
                        e.preventDefault();
                        const forms = document.querySelectorAll('form');
                        forms.forEach((form) => {
                          // Create a temporary hidden submit button
                          const hiddenSubmitButton = document.createElement('button');
                          hiddenSubmitButton.type = 'submit';
                          hiddenSubmitButton.style.display = 'none';
                          form.appendChild(hiddenSubmitButton);

                          hiddenSubmitButton.click(); // Trigger the submit action
                          form.removeChild(hiddenSubmitButton); // Clean up
                        });
                        setShowSave(!showSave);
                      } else {
                        setShowSave(!showSave);
                      }
                    }}
                  >
                    {showSave ? 'Lưu' : 'Sắp xếp'}
                  </CustomButton>
                </div>

                <CustomProTable
                  handleResize={() => { }}
                  columns={columnsSelected}
                  rowKey="stt"
                  bordered
                  options={false}
                  pagination={false}
                  dataSource={workOrderSelected}
                  className="[&_.ant-table-cell]:!p-1 [&_.ant-table-thead>tr>th]:text-[15px]"
                // scroll={{ x: 1700, y: 500 }}
                // className="mt-4 [&_.ant-table-tbody>tr>td]:!font-sans  [&_.ant-pro-card-body]:!p-0 [&_.ant-table-thead>tr>th]:!bg-[#1677FF] [&_.ant-table-thead>tr>th]:!text-white [&_.ant-table-thead>tr>th]:text-[16px] [&_.ant-table-thead>tr>th]:!font-bold"
                />

                {/* các lệnh sản xuất đang chờ */}
                <div className="flex justify-between text-xl">
                  <h4 className="font-bold text-base mt-2">
                    Các LSX có công đoạn {dataProduct && dataProduct?.congDoan} chưa chọn máy/chuyền
                  </h4>
                </div>
                <CustomProTable
                  handleResize={() => { }}
                  columns={columnsPending.filter(
                    (column) =>
                      column.dataIndex !== 'stt' &&
                      column.dataIndex !== 'thuTuCongDoan' &&
                      column.dataIndex !== 'hdsx' &&
                      column.dataIndex !== 'nvlSuDung' &&
                      column.dataIndex !== 'soSPToCongDoan' &&
                      column.dataIndex !== 'soLuongToQuyDoi' &&
                      column.dataIndex !== 'chucNang',
                  )}
                  rowKey="stt"
                  bordered
                  options={false}
                  pagination={false}
                  dataSource={workOrderPendings}
                  className="[&_.ant-table-cell]:!p-1 [&_.ant-table-thead>tr>th]:text-[15px]"
                />
              </div>
            </div>
          ) : (
            <LoadingBCScreen />
          )}

          {dataESR && (
            <div
              className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-7 ${showCard ? 'block' : 'hidden'
                }`}
            >
              {dataESR.map((it, id) => {
                return (
                  <div
                    key={id}
                    className={`
                        ${it.status === StatusColor.HD ? 'bg-green-500' : ''}
                    ${it.status === StatusColor.CM ? 'bg-[#FEF5AC]' : ''}
                    ${it.status === StatusColor.VS ? 'bg-[#C1EFFF]' : ''}
                    ${it.status === StatusColor.NM ? 'bg-[#FFB3B3]' : ''}
                    ${it.status === StatusColor.ET ? 'bg-white' : ''}
                    ${it.id === idSelected ? ' !border-orange-500 border-2' : ''}
                        col-span-1 p-3 font-semibold rounded-2xl m-2 text-sm shadow-md shadow-gray-800/80`}
                  >
                    <div className="text-xs">
                      <div>
                        <h1 className="font-bold text-center min-h-[30px]">{it.equipmentName}</h1>
                      </div>
                      <div className="pb-1 flex items-center gap-3 justify-center border-b border-black border-dashed my-1">
                        <img
                          className=" text-black"
                          width={60}
                          src={it.type?.startsWith('C') ? electro : arm}
                          alt="robotArm"
                        />
                        <span>{it.status}</span>
                      </div>
                      <div className="flex items-center">
                        <DescriptionIcon />
                        <Tooltip title={it.kssxNumber}>
                          <div className="flex-1 clamp-1">{it.kssxNumber}</div>
                        </Tooltip>
                      </div>
                      <div className="flex">
                        <AllInboxSharpIcon className="mb-2" />
                        <div>
                          <div>{it.productCode}</div>
                          <Tooltip title={it.productName}>
                            <div className="lg:w-[150px] lg:truncate xl:w-[150px] xl:truncate">{it.productName}</div>
                          </Tooltip>
                        </div>
                      </div>
                      <div>
                        <PersonIcon />
                        <span>{it.numberWorker && it.numberWorker >= 1 ? it.numberWorker + ' người' : ''}</span>
                      </div>
                      <div>
                        <AccessTimeFilledIcon />
                        <span>
                          {it.hourStart} {it.hourEnd !== null ? ' đến ' : ''} {it.hourEnd}
                        </span>
                      </div>
                    </div>

                    <div className="text-xs">
                      <div className="border-b-[3px] border-black  border-dashed my-1"></div>
                      <div>
                        {it.nextWorkOrder &&
                          it.nextWorkOrder.split(',').map((s, index) => (
                            <div key={index}>
                              <span>{s}</span>
                              <br />
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* modal antd */}
        <>
          <Modal
            title={
              <div className="flex flex-col">
                <div className="text-lg text-center uppercase text-[#1677FF]">Chọn máy thực hiện</div>
                <span className="w-full bg-black h-[2px]"></span>
              </div>
            }
            open={open}
            onOk={handleOk}
            okText="Lưu" // Nhãn mới cho nút Submit
            confirmLoading={confirmLoading}
            width={1000}
            onCancel={handleCancel}
            style={{
              borderRadius: 0,
            }}
          >
            <p className="font-bold text-base mb-3">Lệnh sản xuất: {dataPopup?.lsx}</p>
            <ProTable
              columns={columnsPopup}
              rowKey="sttCongDoan"
              bordered
              scroll={{ x: 900, y: 300 }}
              size="small"
              pagination={false}
              dataSource={dataPopup?.chiTiets}
              search={false}
              options={false}
              className="[&_.ant-table-tbody>tr>td]:!font-sans  [&_.ant-pro-card-body]:!p-0 [&_.ant-table-thead>tr>th]:!bg-[#1677FF] [&_.ant-table-thead>tr>th]:!text-white [&_.ant-table-thead>tr>th]:!font-bold"
            />
          </Modal>
        </>
      </div>
    );
  });
}
